import React from "preact/compat";
import { ModalFooterProps } from "./modalFooter.type";

export const ModalFooter: React.FunctionComponent<ModalFooterProps> = ({
    className,
    children
}) => {
    return (
        <div className={`modal-footer ${className}`}>
            {children}
        </div>
    )
}